/**
 * FCM token register/deregister transport (ONE binding).
 *
 * Endpoint mechanics live in `@aegix/web-push` (register POST, deregister
 * **PUT** `rest/notifications/fcm/deregister`, `x-device-id`
 * headers). This module binds them to ONE's authenticated ky transport so
 * auth-refresh and header middleware still apply; ONE's JWT rides the
 * `Authorization: JWT <token>` scheme.
 */
import { client } from '@/lib/http-client';
import { createFcmApi, type WebPushRegistrationPayload } from '@aegix/web-push';

export type FcmRegistrationPayload = WebPushRegistrationPayload;

const api = createFcmApi(client.ky);

export async function registerFcmToken(
  payload: FcmRegistrationPayload,
): Promise<void> {
  // ONE ignores the response body.
  await api.register(payload);
}

export async function deregisterFcmToken(
  token: string,
  deviceId: string | null,
): Promise<void> {
  await api.deregister(token, deviceId);
}
